module.exports = __webpack_public_path__ + "static/media/amazon-pdp.5c156cfe.jpg";